module.exports = __webpack_public_path__ + "img/jewellery.36161ddb.svg";